import VoyageFuelData from "../data";

export default function voyageFuelDataFromJson(json) {
    return new VoyageFuelData(
        json.id,
        json.cost,
        json.ncv,
        json.tag,
        json.type,
    );
}